module.exports = new __parcel__URL__("inquiry_en.ae9f5d79.webp").toString();